/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
//utils
import { generateDefaultStartDate, generateDefaultEndDate } from 'utils/datePickerDefaultDates';
// material
import {
    Page,
    Content,
    Title,
    LoadState,
    StandardPagination,
    debounce,
    abbreviatedMonths,
    Tip,
    Icon
} from '@insticator/insticator-ui'; // iui-material
import ControlBar from 'material/embeds/controlbar/controlbar';
import ContentAnalyticsCard from 'material/embeds/contentanalyticscard/contentanalyticscard_container';
import BackToEmbedsCTA from 'material/ctas/backtoembeds/backtoembeds';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/analytics/embedcontent/embedcontent_styles';



/* ========== ~~~~~~~~~~ EMBED CONTENT ~~~~~~~~~~ ========== */
class EmbedContent extends Component {
    constructor(props) {
        super(props);
        this.itemsPerPage = 20;
        this.state = {
            filteredItems: this.objectToArray(this.props.contents.contents),
            navigatingToEditor: false,

            keyword: '',
            orderBy: "QUEUE_POSITION",//"CREATED_AT"/"ENGAGEMENT",
            orderDirection: null,
            dateRange: {
                from: generateDefaultStartDate(),//null,
                to: generateDefaultEndDate(), //null,
            },
            // empty array for nothing selected or everything selected ("QUIZ", "POLL", "STORY")
            contentTypes: [], // ["QUIZ", "STORY"],
            contentLive: []//true/false,
        };
    }

    componentDidMount() {
        this.applyFilters(1);
    }

    objectToArray = obj => {
      let arr = [];
      Object.keys(obj).forEach(id => arr.push(obj[id]))
        return arr;
    };

    getDetail = (content) => ((content.contentType === 'story') ? content.story : content.questionBased);

    applyFilters = (page = 1) => {
        //thiis will make the api call to fetch the content
        this.props.getAnalytics(this.props.embedUUID, this.transpileFilterData(page, this.state));
    };

    transpileFilterData = (page, state) => ({
        keyword: state.keyword,
        orderBy: state.orderBy,
        orderDirection: state.orderDirection,
        startDate: state.dateRange.from,
        endDate: state.dateRange.to,
        // empty array for nothing selected or everything selected ("QUIZ", "POLL", "STORY")
        contentTypes: state.contentTypes,
        contentLive: state.contentLive.length === 1 ? state.contentLive[0] : null,
        page: page
    });

    handleSearch = debounce(typedText => this.setState({ keyword: typedText }, this.applyFilters), 400);

    engageEditor = () => {
        if(!this.state.navigatingToEditor) this.setState({ navigatingToEditor: true });
    };

    _renderContents() {
        return this.objectToArray(this.props.contents.contents).map(content => <ContentAnalyticsCard key={this.getDetail(content).contentUUID}
                                                                            content={content}
                                                                            embedUUID={this.props.embedUUID}
                                                                            engageEditor={this.engageEditor}
                                                                            navigatingToEditor={this.state.navigatingToEditor} />);
    }

    handleSelectType = (types) => this.setState({contentTypes: types});


    handleSelectStatus = (status) => this.setState({ contentLive: status });


    handleSort = (sortby) => this.setState({orderDirection: sortby.dir, orderBy: sortby.value}, this.applyFilters);


    handleDateSelect = dateRange => this.setState({ dateRange });

    customDateSelect = dateRange => this.setState({ dateRange }, this.applyFilters);

    handlePagination = direction => {
        if(direction === 'previous'){
           return this.applyFilters(this.props.currentPage - 1);
        }
        return this.applyFilters(this.props.currentPage + 1);
    };

    renderPagination = () => {
        if(this.props.totalRows > this.itemsPerPage){
            return (
                <StandardPagination
                    currentIndex={this.props.currentPage * this.itemsPerPage}
                    itemsPerPage={this.itemsPerPage}
                    totalItems={this.props.totalRows}
                    firstLastButtons={false}
                    handlePrevious={this.handlePagination}
                    handleNext={this.handlePagination} />
            )
        }
    };

    renderLastUpdated = () => {
        if(!!this.props.lastUpdatedAt){
            let testDate = new Date(this.props.lastUpdatedAt);
            let hour = testDate.getHours();
            let AmPm = hour >= 12 ? 'PM' : 'AM';
            let standardHour = hour > 12 ? hour - 12 : hour;
            let date = `${abbreviatedMonths[testDate.getMonth()]} ${testDate.getDate()} at ${standardHour + 1}${AmPm}`;
            return <div>Data last updated: {date} EST <Tip icon={'question-circle'} content={this.tooltipContent}/></div>
        }
        return null;
    };

    tooltipContent = (
        <div style={{ textAlign: 'left' }}>
            <span style={{display: 'inline-flex'}}><div style={{marginRight: '10px'}}><Icon name={'check'}/></div> Data is updated every hour.</span>
            <br/>
            <span style={{display: 'inline-flex'}}><div style={{marginRight: '10px'}}><Icon name={'check'}/></div> All data displayed and available is <br/> in EST time zone.</span>
        </div>
    );

    render() {
        return(
            <Page name={`embedcontent`} klass={`${this.props.classes.embedcontent}`}>
                <Content>
                    <Title variant={'withctas'}>
                        {/*<h2>{this.props.embedName}</h2>*/}
                        <BackToEmbedsCTA />
                        {/*<CTAs name={`ctas`}>
                            <Button type={'action'} action={this.moveToEmbedManagement} variant={`primary`} name={`editembed`} text={`Edit Embed`} />
                        </CTAs>*/}
                    </Title>
                    <ControlBar
                        page={'embedcontent'}
                        handleSort={this.handleSort}
                        disabled={this.props.fetchingAnalytics}
                        label={this.renderLastUpdated()}
                        searchPlaceholder={`Search cards`}
                        searchOnChange={this.handleSearch}
                        handleSelectType={this.handleSelectType}
                        handleSelectStatus={this.handleSelectStatus}
                        updateDateRange={this.handleDateSelect}
                        customRangeClick={this.customDateSelect}
                        dateRange={this.state.dateRange}
                        applyFilters={()=>this.applyFilters(1)}
                    />
                    {this.props.fetchingAnalytics ? <LoadState /> :
                    <div>
                        <Title size={`small`} name={`numberof`}>
                            <h3>
                                <span className={`total`}>Total Cards ({this.props.totalRows})</span>
                                {/*{this.props.totalRows === this.objectToArray(this.props.contents.contents) ? null :*/}
                                {/*    <span className={`filtered`}>Sorted Cards ({this.objectToArray(this.props.contents.contents).length})</span>*/}
                                {/*}*/}
                            </h3>
                        </Title>
                        <div className={`cards`}>
                            {this._renderContents()}
                        </div>
                        {this.renderPagination()}
                    </div>}
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedContent);
